import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import React from 'react';
import { Bar } from 'react-chartjs-2';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const BarChart = ({ chartLabels, chartData, optional = {} }) => {
	const options = {
		responsive: true,
		aspectRatio: 9,
		maintainAspectRatio: true,
		plugins: {
			...optional?.plugins,
			legend: {
				display: false
			}
		},
		...optional
	};

	const labels = chartLabels;
	const data = {
		labels,
		datasets: chartData
	};
	// console.log('chartLabels:', chartLabels);
	// console.log('chartData:', chartData);
	// console.log('Data:', data);
	// console.log('options:', options);

	return <Bar options={options} data={data} />;
};

export default BarChart;
